// Aliased target so `popper.js` imports reuse window.Popper from vendor_globals.
// CommonJS, for the reason in shims/jquery.js.
module.exports = window.Popper;
